import abi from "./Transactions.json";

export const contractAddress = "0xe5570965A764b52A80eEa834B68b7BB300056824";
export const contractABI = abi.abi;
